'use es6';

import { ObjectCategory } from 'FileManagerCore/Constants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { connect } from 'react-redux';
import H4 from 'UIComponents/elements/headings/H4';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILink from 'UIComponents/link/UILink';
import UIBackButton from 'UIComponents/nav/UIBackButton';
import { selectFile } from '../actions/Actions';
import { navigateToFolder } from '../actions/Folders';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getI18nKey = (category, suffix) => `FileManagerDashboard.${category === ObjectCategory.FOLDER ? 'noFolderAccess' : 'noFileAccess'}.${suffix}`;
const NoAccessAsset = ({
  navigate,
  category,
  handleSelectFile
}) => /*#__PURE__*/_jsxs(UIErrorMessage, {
  illustration: "lock",
  illustrationProps: {
    width: 200
  },
  title: /*#__PURE__*/_jsx(H4, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: getI18nKey(category, 'header')
    })
  }),
  children: [/*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: getI18nKey(category, 'subheader')
    })
  }), /*#__PURE__*/_jsx(UIBackButton, {
    children: /*#__PURE__*/_jsx(UILink, {
      onClick: () => {
        handleSelectFile(null);
        navigate(null);
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "FileManagerDashboard.noFolderAccess.back"
      })
    })
  })]
});
const mapDispatchToProps = {
  navigate: navigateToFolder,
  handleSelectFile: selectFile
};
NoAccessAsset.propTypes = {
  navigate: PropTypes.func.isRequired,
  category: PropTypes.oneOf([ObjectCategory.FILE, ObjectCategory.FOLDER]),
  handleSelectFile: PropTypes.func.isRequired
};
export default connect(null, mapDispatchToProps)(NoAccessAsset);